/**
 * 会议管理 - 会议创建成功
 *
 * @file success.js
 * @author yangwei(yangwei14@baidu.com)
 */
import _ from 'lodash';
import {Component} from 'san';

import {asPage} from '../../helper';
import {html} from '../../common/raw';
import {redirect, formatTime, getEndTime, getTimeStamp, genRoomUrl, genOwnReadyPageUrl} from '../../common/utils';
import {
    Button,
    Icon,
    Clipboard,
    Row,
    notification
} from '@baiducloud/bce-ui';
import MeetingContent from '../../components/meeting-config';
import client from '../../../client';

@asPage('/meeting/success')
export default class extends Component {
    static components = {
        'ui-icon': Icon,
        'ui-clipboard': Clipboard,
        'ui-row': Row,
        'ui-button': Button,
        'ui-content': MeetingContent
    }
    static filters = {
        format: time => formatTime(time * 1000),
        maxFiftyLen: str => {
            if (!str) {
                return;
            }
            return str.length < 50 ? str : `${str.slice(0, 50)}...`;
        },
        genRoomUrl
    }
    static template = html`
    <template>
        <div class="list-content meeting-success">
            <div class="create-header">
                <div class="return" on-click="returnList">
                    <ui-icon name="arrow-left" />返回会议列表
                </div>
                {{data.room_url ? '创建成功' : '预约会议'}}
            </div>
            <div class="create-success" s-if="data.room_url">
                <div class="create-tick succ-item">
                    <ui-icon name="correct" />
                </div>
                <div class="create-text succ-item">会议已创建成功，点击下方链接直接入会！</div>
                <div class="succ-item copy-url">
                    <a href="{{data.room_url}}" target="_blank">{{data.room_url | maxFiftyLen}}</a>
                </div>
                <div class="succ-item">
                    <div class="copy-con">
                        <ui-clipboard
                            text="{{data | genRoomUrl}}"
                            tip-position="e"
                            layer-style="{{copyUrlLayerStyle}}"
                        >
                            <ui-icon name="copy"/>
                            <ui-button
                                skin="stringfy">
                                复制会邀
                            </ui-button>
                        </ui-clipboard>
                    </div>
                </div>
                <div class="text-grey succ-item">
                    其他参会人也可通过此链接进入会议，复制给参会人即可
                </div>
            </div>
            <div class="create-detail" s-if="data.room_name">
                <div class="detail-header">
                    <span class="detail-text">会议详情</span>
                    <div class="detail-edit" on-click="editMeeting">
                        <ui-icon name="bcmedit"></ui-icon>
                        修改
                    </div>
                </div>
                <div class="detail-item">
                    <div class="detail-label">会议主题：</div>
                    <div class="detail-value ellipsis" title="{{data.room_name}}">
                        {{data.room_name}}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-label">开始时间：</div>
                    <div class="detail-value ellipsis">{{data.room_stime | format}}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-label">会议时长：</div>
                    <div class="detail-value ellipsis">{{data.room_dtime}}分钟</div>
                </div>
                <div class="detail-item">
                    <div class="detail-label">会议地点：</div>
                    <div class="detail-value ellipsis" title="{{data.room_name}}">
                        {{data.room_site}}</div>
                </div>
            </div>
        </div>
    `;
    initData() {
        return {
            data: {},
            copyUrlLayerStyle: {
                width: '150px'
            }
        };
    }
    attached() {
        let query = this.data.get('route.query');
        query && query.mode && query.mode === 'startnow' && this.startNow();
        if (query && query.id) {
            this.getData(query.id);
        }
    }
    async startNow() {
        this.data.set('loading', true);
        let timeNow = new Date().getTime();
        /* eslint-disable fecs-camelcase */
        let payload = {
            room_name: '视频会议',
            room_desc: '',
            room_stime: getTimeStamp(timeNow),
            room_etime: getTimeStamp(getEndTime(timeNow, 180)),
            room_dtime: 180,
            room_partner: [],
            room_owner: {
                username: ''
            },
            room_site: '线上远程',
            room_type: 0
        };
        /* eslint-disable fecs-camelcase */
        const data = await client.scheduleMeeting(payload);
        if (data.status === 0) {
            let arr = data.data;
            arr.room_url = genOwnReadyPageUrl(arr, true);
            this.data.set('data', arr);
            this.data.set('loading', false);
        }
        else {
            notification.error(data.message);
        }
    }
    async getData(id) {
        this.data.set('loading', true);
        const data = await client.getMeetingList();
        const arr = _.filter(data.data.rows, item => item.room_id === Number(id))[0];
        arr.room_url = genOwnReadyPageUrl(arr, true);
        arr && this.data.set('data', arr);
        this.data.set('loading', false);
    }
    editMeeting() {
        const query = this.data.get('route.query');
        if (query && query.id) {
            redirect(`#/meeting/create?mode=modify&id=${query.id}`);
        }
        const data = this.data.get('data');
        if (data && data.room_id) {
            redirect(`#/meeting/create?mode=modify&id=${data.room_id}`);
        }
    }
    returnList() {
        redirect('#/meeting/list');
    }
}
